<link rel="stylesheet" href="ticket-status.component.scss">
<ng-container [ngTemplateOutlet]="statusBubble"
              [ngTemplateOutletContext]="{status: ticket.status, isStart: true}">
</ng-container>

<div class="row" *ngFor="let operation of operations; let index">
    <div class="line"></div>
    <ng-container [ngTemplateOutlet]="operationBubble"
                  [ngTemplateOutletContext]="{operation: operation}">
    </ng-container>
</div>

<div class="line"></div>
<ng-container [ngTemplateOutlet]="statusBubble"
              [ngTemplateOutletContext]="{status: ticket.status, isStart: false}">
</ng-container>


<ng-template #statusBubble let-status="status" let-isStart="isStart">
    <div class="column">
        <div class="status-bubble"
             [class.finished]="isStart ? status === 'InProgress' || status === 'Closed' || status === 'OnHold': status === 'Closed'"
             [class.in-progress]="isStart && status==='Ready'"
             [class.not-started]="isStart ? status !== 'InProgress' && status !== 'Closed' && status !== 'OnHold' : status !== 'Closed'"
             (click)="toggleInfoBubble(isStart)">
            <p>{{
                    isStart
                        ? ('service.tickets.details.status-component.new' | translate)
                        : ('service.tickets.details.status-component.finished' | translate)
                }}
            </p>
        </div>
        <ng-container *ngIf="isStart && startBubbleExpanded"
                      [ngTemplateOutlet]="ticketStartDetails"
                      [ngTemplateOutletContext]="{ticket: ticket}">
        </ng-container>
        <ng-container *ngIf="!isStart && finishBubbleExpanded"
                      [ngTemplateOutlet]="ticketFinishDetails"
                      [ngTemplateOutletContext]="{ticket: ticket}">
        </ng-container>
    </div>
</ng-template>

<ng-template #operationBubble let-operation="operation">
    <div class="column">
        <div class="status-bubble"
             (click)="toggleExpanded(operation)"
             [class.finished]="operation.status=='Resolved'"
             [class.canceled]="operation.status=='Unresolved'"
             [class.in-progress]="operation.status==='InProgress'"
             [class.not-started]="operation.status==='New'"
             [class.on-hold]="operation.status==='OnHold'">
            <p>{{ operation.name }}</p>
        </div>
        <ng-container *ngIf="isExpanded(operation)"
                      [ngTemplateOutlet]="operationDetails"
                      [ngTemplateOutletContext]="{operation: operation}">
        </ng-container>
    </div>
</ng-template>

<ng-template #operationDetails let-operation="operation">
    <div class="extension">
        <p>{{ 'service.tickets.details.status-component.started' | translate }}
            : {{ operation.status === 'New' ? ('service.tickets.details.status-component.notStarted' | translate) : operation.startDate }}</p>
        <p>{{ 'service.tickets.details.status-component.ended' | translate }}: {{
                operation.status === 'Resolved' ?
                    operation.endDate : (operation.status === 'New' ? ('service.tickets.details.status-component.notStarted' | translate) :
                        (operation.status === 'OnHold' ? ('service.tickets.details.status-component.onHold' | translate) :
                            (operation.status === 'Unresolved' ? ('service.tickets.details.status-component.unresolved' | translate) : 'In progress')))
            }}</p>
        <p>{{ 'service.tickets.details.status-component.timeSpent' | translate }}
            : {{ operation.status === 'Resolved' ? computeTimeSpent(operation) : 'N/A' }}</p>
        <p>{{ 'service.tickets.details.status-component.status' | translate }}: {{ operation.status || 'N/A' }}</p>
        <p>{{ 'service.tickets.details.status-component.assignedTo' | translate }}
            : {{ operation.assignedTo?.id != 0 ? operation.assignedTo?.fullName : 'N/A' }}</p>
        <p>{{ 'service.tickets.details.status-component.comment' | translate }}
            : {{ (operation.comment && operation.comment != 'null') ? operation.comment : 'N/A' }}</p>
        <p class="document" (click)="downloadDocument($event, operation)"
           *ngIf="operation.document">{{ 'service.tickets.details.status-component.document' | translate }}
            : {{ operation.document?.name || 'N/A' }}</p>
    </div>
</ng-template>

<ng-template #ticketStartDetails let-ticket="ticket">
    <div class="extension">
        <p>{{ 'service.tickets.details.status-component.startedAt' | translate }}
            : {{ ticket.status === 'InProgress' ? ticket.startDate : 'N/A' }}</p>
    </div>
</ng-template>

<ng-template #ticketFinishDetails let-ticket="ticket">
    <div class="extension">
        <p>{{ 'service.tickets.details.status-component.finishedAt' | translate }}
            : {{ ticket.status === 'Closed' ? ticket.endDate : 'N/A' }}</p>
    </div>
</ng-template>
